const initialState = {
  AllRestaurants: [],
};

export default function restaurantsReducer(state = initialState, action) {
  switch (action.type) {
    case "RESTAURANTS_FETCHED": {
      console.log("3", action.payload);
      return {
        AllRestaurants: action.payload,
      };
    }

    case "RESTAURANT_FETCHED_BY_ID": {
      console.log("3", action.payload);
      return {
        AllRestaurants: [action.payload],
      };
    }

    default: {
      return state;
    }
  }
}
